import { Injectable } from '@angular/core';
import { TerceroService } from './tercero.service';
import { UserSession } from '../domain/user-session';
import { GenericResponse } from '../domain/genericResponse';
import { GLOBAL } from '../global';
import { GrupoMenu } from '../domain/grupo-menu';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  public menu: Array<GrupoMenu>; 

  constructor(private terceroService: TerceroService,
              private authService: AuthService) {
    this.menu = new Array<GrupoMenu>();
  }

  loadMenu(userSession : UserSession) : void {
    let listaMenu: Array<GrupoMenu>;

    if (userSession != null && userSession.role != GLOBAL.ROL_USUARIO_FINAL) {
      this.terceroService.loadMenu(userSession.sub).subscribe(data => {
        let respuestaGenerica: GenericResponse = data;
        if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {
          listaMenu = respuestaGenerica.lista;
          this.menu = listaMenu;
        }
      }, error => {

      }
      );
    } else {
      this.terceroService.loadMenuUsuario().subscribe(data => {
        let respuestaGenerica: GenericResponse = data;
        if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {
          listaMenu = respuestaGenerica.lista;
          this.menu = listaMenu;
        }

      }, error => {

      }
      );
    }

    //console.log(this.menu);
  }
}
